module.exports = ".chart {\n    width: 100%;\n    margin-bottom: 30px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/charts/charts.component.css
// module id = ./src/app/charts/charts.component.css
// module chunks = main